<template>
  <v-fade-transition hide-on-leave>
    <div
      class="d-flex row wrap"
      :class="$vuetify.breakpoint.smAndUp ? 'no-gutters' : ''"
    >
      <v-col
        cols="12"
        sm="4"
        :class="$vuetify.breakpoint.smAndUp ? 'px-0' : ''"
      >
        <v-select
          v-model="selectedPhoneCountryCode"
          :items="countries"
          cache-items
          :label="$vuetify.lang.t('$vuetify.COUNTRY_CODE')"
          item-text="country_name"
          item-value="country_name"
          return-object
          outlined
          hide-details
          :style="
            $vuetify.breakpoint.smAndUp
              ? 'border-top-right-radius: 0; border-bottom-right-radius: 0;'
              : ''
          "
          dense
          @change="phoneDiallingCodeChanged($event)"
        >
          <template v-slot:selection="{ item }">
            <span
              :class="
                `flag-icon flag-icon-${item.country_code.toLowerCase()} mr-3`
              "
            ></span>
            {{ item.dialling_code }}
          </template>
          <template v-slot:item="{ item }">
            <span
              :class="
                `flag-icon flag-icon-${item.country_code.toLowerCase()} mr-3`
              "
            ></span>
            {{ item.country_name }}
          </template>
        </v-select>
      </v-col>
      <v-col
        cols="12"
        sm="8"
        d-flex
        align-center
        :class="$vuetify.breakpoint.smAndUp ? 'pl-sm-0 pl-md-0' : ''"
      >
        <v-text-field
          v-model="phoneNumber"
          :style="
            $vuetify.breakpoint.smAndUp
              ? 'border-top-left-radius: 0; border-bottom-left-radius: 0;'
              : ''
          "
          name="phone"
          type="number"
          :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.PHONE_NUMBER')"
          outlined
          hide-details
          dense
          class="d-flex align-center"
          @change="phoneNumberChanged($event)"
        >
          <!-- <template v-slot:message>
            <span v-if="!isValidPhoneNumber" class="error--text">
              Invalid phone number
            </span>
          </template> -->
        </v-text-field>
      </v-col>
    </div>
  </v-fade-transition>
</template>
<script>
import countries from '@/assets/countries'
import { mapGetters } from 'vuex'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import 'flag-icon-css/css/flag-icon.css'
import { EventBus } from '@/event-bus.js'

export default {
  name: 'PhoneSelect',
  props: {
    initialCountryCode: {
      type: String,
      default: 'EST',
      required: false
    },
    initialPhoneNumber: {
      type: String,
      default: '',
      required: false
    }
  },
  data() {
    return {
      countries,
      selectedPhoneCountryCode: null,
      phoneNumber: this.initialPhoneNumber || '',
      verificationCode: null
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    isValidPhoneNumber() {
      if (this.phoneNumber.length > 3 && this.phoneNumber.length <= 17) {
        try {
          const phoneNumberWithCountryCode =
            this.selectedPhoneCountryCode.dialling_code + this.phoneNumber
          const phoneNumber =
            this.phoneNumber !== ''
              ? parsePhoneNumberFromString(phoneNumberWithCountryCode)
              : ''
          return phoneNumber !== ''
        } catch (error) {
          return false
        }
      }
      return false
    }
  },
  async mounted() {
    if (!this.initialPhoneNumber) {
      this.selectedPhoneCountryCode = this.countries.find(country =>
        country.country_code_iso_3 === this.initialCountryCode
          ? this.initialCountryCode
          : this.getUserCountryCodeByIp()
      )
    } else {
      let diallingCode = ''
      let countryCodeFromList = ''
      let ipCountryCode = ''
      if (this.initialCountryCode && this.initialCountryCode.length) {
        const r = this.parsePhoneNumber(this.initialPhoneNumber)
        countryCodeFromList = this.countries.find(
          country =>
            country.country_code_iso_3 === r.selectedCountry.country_code_iso_3
        )
      } else {
        ipCountryCode = await this.getUserCountryCodeByIp()
        countryCodeFromList = this.countries.find(
          country => country.country_code_iso_3 === ipCountryCode
        )
      }
      if (countryCodeFromList) {
        diallingCode = countryCodeFromList.dialling_code.replace('+', '')
        this.selectedPhoneCountryCode = countryCodeFromList
      }
      if (
        this.initialPhoneNumber.startsWith(diallingCode) &&
        !this.initialPhoneNumber.includes('+')
      ) {
        this.phoneNumber = this.initialPhoneNumber.replace(diallingCode, '')
        EventBus.$emit('phoneNumberChanged', {
          event: this.initialPhoneNumber.replace(diallingCode, ''),
          valid: this.isValidPhoneNumber
        })
        EventBus.$emit('phoneDiallingCodeChanged', {
          event: countryCodeFromList || '',
          valid: this.isValidPhoneNumber
        })
      } else if (
        this.initialPhoneNumber.includes('+') &&
        this.initialPhoneNumber.startsWith(countryCodeFromList.dialling_code)
      ) {
        this.phoneNumber = this.initialPhoneNumber.replace(
          countryCodeFromList.dialling_code,
          ''
        )
        EventBus.$emit('phoneNumberChanged', {
          event: this.phoneNumber,
          valid: this.isValidPhoneNumber
        })
        EventBus.$emit('phoneDiallingCodeChanged', {
          event: countryCodeFromList || '',
          valid: this.isValidPhoneNumber
        })
      } else {
        this.phoneNumber = this.initialPhoneNumber || ''
        EventBus.$emit('phoneDiallingCodeChanged', {
          event: countryCodeFromList || '',
          valid: this.isValidPhoneNumber
        })
      }
    }
  },
  methods: {
    async getUserCountryCodeByIp() {
      // const ipData = await fetch(
      //   'https://api.ipdata.co?api-key=3c271270bcba7526087e2bd5c49354d838c374d92c1249c2a85d8df1'
      // )
      // if (ipData.ok) {
      //   return ipData.body.country_code
      // }
      fetch('https://ip2c.org/s')
        .then(response => response.text())
        .then(response => {
          const result = (response || '').toString()

          if (!result || result[0] !== '1') {
            throw new Error('unable to fetch the country')
          }
          const selectedCountry = this.countries.find(
            country => country.country_code === result.substr(2, 2)
          )
          return selectedCountry.country_code
        })
      return 'EST'
    },
    phoneNumberChanged(event) {
      EventBus.$emit('phoneNumberChanged', {
        event,
        valid: this.isValidPhoneNumber
      })
      EventBus.$emit('phoneDiallingCodeChanged', {
        event: this.selectedPhoneCountryCode,
        valid: this.isValidPhoneNumber
      })
    },
    phoneDiallingCodeChanged(event) {
      const code = event.dialling_code.replace('+', '')
      if (this.phoneNumber.startsWith(code)) {
        this.phoneNumber = this.phoneNumber.replace(code, '')
        EventBus.$emit('phoneNumberChanged', {
          event: this.phoneNumber,
          valid: this.isValidPhoneNumber
        })
      }
      EventBus.$emit('phoneDiallingCodeChanged', {
        event,
        valid: this.isValidPhoneNumber
      })
    },
    parsePhoneNumber(initialPhoneNumber) {
      let selectedCountry = null
      let parsedPhoneNumber = initialPhoneNumber

      this.countries.some(country => {
        const diallingCode = country.dialling_code.replace('+', '')

        if (initialPhoneNumber.startsWith(diallingCode)) {
          selectedCountry = country
          parsedPhoneNumber = initialPhoneNumber.replace(diallingCode, '')
          return true
        }
        return false
      })

      return { selectedCountry, parsedPhoneNumber }
    }
  }
}
</script>
